<!-- Accessibility enabled template -->
<ng-container *ngIf="enableDataTableAccessibility$ | async; else oldTemplate">
  <button
    *ngIf="isDropdown"
    [ngStyle]="{
      backgroundColor: btnBGColor,
      color: btnColor,
      border: btnOutline
    }"
    (click)="click()"
    type="button"
    [ngClass]="{
      'btn-secondary-hover-effected': isOpenGovTheme && style === 'secondary',
      'btn-primary-hover-effected': isOpenGovTheme && style !== 'secondary',
      'accessibility-enabled': true
    }"
    class="d-flex justify-content-center"
    [attr.aria-label]="accessibleLabel"
    [attr.aria-expanded]="false"
    [attr.aria-haspopup]="true"
    ngbDropdownToggle
  >
    <span>
      {{ title }}
    </span>
  </button>

  <button
    *ngIf="!isDropdown"
    [ngStyle]="{
      backgroundColor: disabled ? 'var(--background-disabled)' : btnBGColor,
      color: btnColor,
      border: btnOutline
    }"
    (click)="click()"
    [disabled]="disabled || loading"
    [type]="type"
    [ngClass]="{
      'btn-secondary-hover-effected': isOpenGovTheme && style === 'secondary',
      'btn-primary-hover-effected': isOpenGovTheme && style !== 'secondary' && !disabled,
      'accessibility-enabled': true
    }"
    class="d-flex justify-content-center"
    [attr.aria-label]="accessibleLabel"
    [attr.aria-disabled]="disabled || loading"
    [attr.aria-busy]="loading"
  >
    <span *ngIf="!loading">
      {{ title }}
    </span>
  </button>
</ng-container>

<!-- Original template (flag OFF) -->
<ng-template #oldTemplate>
  <button
    *ngIf="isDropdown"
    [ngStyle]="{
      backgroundColor: btnBGColor,
      color: btnColor,
      border: btnOutline
    }"
    (click)="click()"
    type="button"
    [ngClass]="{
      'btn-secondary-hover-effected': isOpenGovTheme && style === 'secondary',
      'btn-primary-hover-effected': isOpenGovTheme && style !== 'secondary' 
    }"
    class="d-flex justify-content-center"
    ngbDropdownToggle
  >
    <span>
      {{ title }}
    </span>
  </button>

  <button
    *ngIf="!isDropdown"
    [ngStyle]="{
      backgroundColor: disabled ? 'var(--background-disabled)' : btnBGColor,
      color: btnColor,
      border: btnOutline
    }"
    (click)="click()"
    [disabled]="disabled || loading"
    [type]="type"
    [ngClass]="{
      'btn-secondary-hover-effected': isOpenGovTheme && style === 'secondary',
      'btn-primary-hover-effected': isOpenGovTheme && style !== 'secondary' && !disabled
    }"
    class="d-flex justify-content-center"
  >
    <span *ngIf="!loading">
      {{ title }}
    </span>
  </button>
</ng-template>
